import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';
import STATISTICS from 'SharedDir/backend/endpoints/statistics';
import { Statistics } from 'SharedDir/declarations/statistics';

export default class StatisticsApiClass {
  async getLogins(params?: Statistics.LoginStatisticFilters): Promise<Statistics.Statistic[]> {
    const { data } = await http({
      ...STATISTICS.LOGINS,
      params,
    });
    return data;
  }

  async getRegistration(
    params?: Statistics.RegistrationStatisticFilters
  ): Promise<Statistics.Statistic[]> {
    const { data } = await http({
      ...STATISTICS.REGISTRATION,
      params
    });
    return data;
  }
}
